import { render, staticRenderFns } from "./plantingTreesTable.vue?vue&type=template&id=63e4a77e"
import script from "./plantingTreesTable.vue?vue&type=script&lang=js"
export * from "./plantingTreesTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports